module.exports = __webpack_public_path__ + "static/media/profile.090a5aab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile.jpg
// module id = 5881
// module chunks = 0